import React, {useEffect, useState} from 'react';
import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from "./App"
import ErrorPage from "./ErrorPage";
import SetupApp from "./SetupApp";
import GenerateApp from "./GenerateApp";

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import {GlobalState} from "./GlobalState";
import LoginSuccessApp from "./login/LoginSuccessApp";
import LogoutApp from "./login/LogoutApp";
import LoginApp from "./login/LoginApp";
import axios from "axios";
import {Company} from "./Company";
import FetchSessionApp from "./FetchSessionApp";

//const backend_uri = "http://localhost:5000";
const backend_uri = "https://genpostbackend39.azurewebsites.net";

axios.defaults.headers.common['Access-Control-Allow-Origin'] = "*";
axios.defaults.headers.common['session'] = localStorage.getItem('session');
axios.defaults.withCredentials = true;

const dummyCompany: Company = {id: "", name: "", description: "", type: ""};

function Main() {
    const [globalState, setGlobalState] = useState<GlobalState>({});
    console.log(localStorage.getItem('session'));
    const setCompanyType = (newType: string) => {
        if (!globalState.company || globalState.company === dummyCompany) {return;}
        globalState.company.type = newType;
        setGlobalState(globalState);
        axios.post(`${backend_uri}/company`, globalState.company)
    };

    const setCompanyDescription = (newDesc: string) => {
        if (!globalState.company || globalState.company === dummyCompany) {return;}
        globalState.company.description = newDesc;
        axios.post(`${backend_uri}/company`, globalState.company)
    };



    useEffect(() => {
        axios.get(`${backend_uri}/company`)
             .then(el => setGlobalState({company: el.data as unknown as Company}))
             .catch( err => {
                 console.log(err);
                if (err.response.status !== 401) {
                    throw err;
                }
            }
        )
    }, []);

    const router = createBrowserRouter([
        {
            path: "/",
            element: <App company={globalState.company}/>,
            errorElement: <ErrorPage />
        },
        {
            path: "generate",
            element: <GenerateApp company={globalState.company ?? dummyCompany}
                                  clearBackendUri={`${backend_uri}/generate/clean`}
                                  generateBackendUri={`${backend_uri}/generate`}
                                  sendImageUri={`${backend_uri}/generate/upload_file`}
                                  squareItemsUri={`${backend_uri}/generate/items`}
            />,
        },
        {
            path: "setup",
            element: <SetupApp company={globalState.company ?? dummyCompany}
                               companyTypesUri={`${backend_uri}/company_types`}
                               setCompanyType={setCompanyType}
                               setCompanyDescription={setCompanyDescription}
            />,
        },
        {
            path: "login",
            element: <LoginApp/>,
        },
        {
            path: "logout",
            element: <LogoutApp setGlobalState={setGlobalState} logoutUri={`${backend_uri}/logout`} />,
        },
        {
            path: "login_success",
            element: <LoginSuccessApp setGlobalState={setGlobalState}/>,
        },
        {
            path: "fetch_session",
            element: <FetchSessionApp redirect_url={"/"}/>,
        }
    ]);

    return <RouterProvider router={router} />;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
      <Main />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
